import { AnyAction } from 'redux'

export const SharedStateAction = 'SharedStateAction'
export const SharedPersistedStateAction = 'SharedPersistedStateAction'

export type SharedStateActionPayload = {
  name: string
  value: any
}

export const sharedStateAction = (payload: SharedStateActionPayload): AnyAction => ({
  type: SharedStateAction,
  payload,
})

export const sharedPersistedStateAction = (payload: SharedStateActionPayload): AnyAction => ({
  type: SharedPersistedStateAction,
  payload,
})

export default {}
